export const CAROUSEL_EXP = 'billing.carousel';
export const BONUS_EXP = 'billing.bonus.selection';
export const PRESELECT_EXP = 'billing.method.preselect';
export const FTD_CARD_PRESELECT_EXP = 'billing.ftd.card.preselect';
export const PRESET_DEPOSIT_AMOUNT_EXP = 'billing.preset.deposit.amount_new';

export const UNKNOWN_EXP = 'unknownFeature';

export const BonusExpValue = {
  SingleSelection: 'single_selection',
  FirstBonusSelection: 'first_bonus_selection',
  NoBonusSelection: 'no_bonus_selection',
  HideBonus: 'hide_bonus',
} as const;

export const FtdCardPreselectExpValue = {
  CardPreselect: 'card_preselect',
  NoPreselect: 'no_preselect',
} as const;
